export default __webpack_public_path__ + "static/media/11.ee8dc875.jpg";